import { handleUrl, myHeadersWithTokenContentType } from '../global';
import {
  DetailProps,
  EditUserProps,
  GetAllUsersProps,
  GetUserProps,
  UserProps,
} from './types';

export const createUser = (data: UserProps): Promise<DetailProps> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/users`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const editUser = (
  id: number,
  data: EditUserProps
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PUT',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/users/${id}`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getAllUsers = (
  page: number,
  size: number,
  search?: string,
  role?: number
): Promise<GetAllUsersProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();

  const params: Record<string, string> = {
    page: String(page),
    size: String(size),
  };
  if (search) params.search_string = search;
  if (role) params.role = String(role);

  const queryString = new URLSearchParams(params).toString();

  return fetch(`${baseUrl}/api/V1/users?${queryString}`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getUser = (
  inspectorId: number,
  workCompanyId?: number
): Promise<GetUserProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  let url = `${baseUrl}/api/V1/users/${inspectorId}?`;

  const paramsUrl = [];

  if (workCompanyId) paramsUrl.push(`worker_company_id=${workCompanyId}`);

  url += paramsUrl.join('');

  return fetch(`${url}`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};
